import styled from "styled-components"

export const CustomInputWrapper = styled.div`
  display: flex;
  align-items: center;
  input {
    font-family: "Roboto Condensed";
  }
`
